import { render, staticRenderFns } from "./PercursoUf.vue?vue&type=template&id=410a49d9"
import script from "./PercursoUf.vue?vue&type=script&lang=js"
export * from "./PercursoUf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports